import React, { useState, useEffect, useRef } from 'react';
import EditOrCreateApplication from '../MyApps/EditOrCreateApplication/EditOrCreateApplication';
import { connect } from 'react-redux';

import { Modal, Button, Form } from 'react-bootstrap';
import CommonConfiramation from '../../../common/base/CommonConfiramation/CommonConfiramation';
import { useCombined } from  '../../../common/base/CombinedContext';
import './_RequestAccess.scss';
import { useToast } from '../../../common/base/ToastContext';
import { fetchAPIInstance, fetchApplications, getSLATiers, reFetchApplication } from '../../actions/request';
import PopupAlert from '../../../common/Alert/PopupAlert';
import { API_BASE_PATH, commonHeaders } from '../../actions/constants';
import { LENGTH_RANGE, TEXT_PATTERN } from '../../../common/base/constants';

function RequestAccess({data, selected, config, ...props}) {
  const defaultPopupData = { title: "", message: "", status: "", showAlert: false, source: "" };
  const resolvedGatewayName = config?.gatewayName?.trim() ? config.gatewayName : 'Flex';
  const allowCustomClientCredentials = config?.allowCustomClientCredentials === undefined
    ? true
    : String(config.allowCustomClientCredentials).toLowerCase() === 'true';
  const resolvedAuthProvider = config?.authProvider?.trim() ? config.authProvider : 'Okta';
  const [apiInstance, setApiInstance] = useState('');
  const [application, setApplication] = useState('');
  const [slaTier, setSlaTier] = useState('');
  // const [requestReason, setRequestReason] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [applications, setApplications] = useState(['Create Application'
  ]);
  const [apiInstances, setApiInstances] = useState([ 
    { 
      "accessRequestsCount": 0, 
      "apiInstanceId": 20969715, 
      "isPublic": false, 
      "apiInstanceName": "dv3", 
      "apiInstanceVersion": "1.0.0", 
      "apiInstanceGroup": "dv3" 
    }, 
    { 
      "accessRequestsCount": 0, 
      "apiInstanceId": 20969716, 
      "isPublic": false, 
      "apiInstanceName": "dv2", 
      "apiInstanceVersion": "1.0.0", 
      "apiInstanceGroup": "nprd" 
    }, 
    { 
      "accessRequestsCount": 0, 
      "apiInstanceId": 20969717, 
      "isPublic": false, 
      "apiInstanceName": "dv1", 
      "apiInstanceVersion": "1.0.0", 
      "apiInstanceGroup": "nprd" 
    } 
    ] );
  const [apiSelectedInstance , setApiSelectedInstance] = useState(null)
  const [popupConfig, setPopupConfig] = useState({});
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { showLoader, hideLoader } = useCombined();
  const [popupData, setPoupupData] = useState(defaultPopupData);

  const [isFormValid, setIsFormValid] = useState(false);
  const selectInstanceRef = useRef(null);
  const selectApplicationRef = useRef(null);
  const selectSlaRef = useRef(null);
  const textAreaRef = useRef(null);
  const [requestReason, setRequestReason] = useState({ value: "", invalid: true, error: false, helpText: `0 / ${LENGTH_RANGE.MAX}`, touched: false });

 // let hostURL = "https://it-developer-nprd-dev.cisco.com"//
  let hostURL = location.protocol + '//' + location.host + '/auth';
  let headers = {
      //  'ru':"rvidyasa",
      //  'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      }
  const [slaTiers, setSlaTiers] = useState({});
  const { showToast } = useToast();

  function groupApiInstances(instances) {
    const grouped = {};
    const ungrouped = [];
    instances.forEach(inst => {
      const group = inst.apiInstanceGroup;
      if (!group) {
        ungrouped.push(inst);
        return;
      }
      if (!grouped[group]) {
        grouped[group] = { ...inst };
      } else {
        grouped[group].apiInstanceId = `${grouped[group].apiInstanceId}, ${inst.apiInstanceId}`;
        grouped[group].apiInstanceName = `${grouped[group].apiInstanceName}, ${inst.apiInstanceName}`;
      }
    });
    return [...Object.values(grouped), ...ungrouped];
  }

  function groupSlaTiersByName(tiersByInstance, selectedInstanceIds) {
    if (Array.isArray(tiersByInstance)) {
      return tiersByInstance;
    }

    if (!tiersByInstance || typeof tiersByInstance !== 'object') {
      return [];
    }

    const instanceIds = selectedInstanceIds?.length ? selectedInstanceIds : Object.keys(tiersByInstance);
    const grouped = {};

    instanceIds.forEach((instanceId) => {
      const tiers = tiersByInstance[instanceId] || [];
      tiers.forEach((tier) => {
        const tierName = tier?.slaTierName;
        if (!tierName) {
          return;
        }

        if (!grouped[tierName]) {
          grouped[tierName] = {
            ...tier,
            slaTierId: String(tier.slaTierId),
            autoApprove: Boolean(tier.autoApprove),
          };
        } else {
          grouped[tierName].slaTierId = `${grouped[tierName].slaTierId}, ${tier.slaTierId}`;
          grouped[tierName].autoApprove = grouped[tierName].autoApprove && Boolean(tier.autoApprove);
        }
      });
    });

    return Object.values(grouped);
  }

  const [groupedInstances, setGroupedInstances] = useState([]);
  const selectedInstanceIds = apiInstance ? apiInstance.split(',').map((id) => id.trim()).filter(Boolean) : [];
  const groupedSlaTiers = groupSlaTiersByName(slaTiers, selectedInstanceIds);
  
  useEffect(() => {
    if(apiInstance) {
        getApplications();
    }
  }, [apiInstance]);

  useEffect(() => {
    if (selectInstanceRef.current) {
      selectInstanceRef.current.value = apiInstance;
    }
  }, [apiInstance, showPopup]);

  useEffect(() => {
    if (selectApplicationRef.current) {
      selectApplicationRef.current.value = application;
    }
  }, [application, showPopup]);

  useEffect(() => {
    if (selectSlaRef.current) {
      selectSlaRef.current.value = slaTier;
    }
  }, [slaTier, showPopup]);

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.value = requestReason.value;
    }
  }, [requestReason.value, showPopup]);

  useEffect(() => {
    const selectInstance = selectInstanceRef.current;
    const selectApplication = selectApplicationRef.current;
    const selectSla = selectSlaRef.current;
    if (!selectInstance || !selectApplication || !selectSla) {
      return;
    }
    
    if (!showPopup) {
      selectInstance.removeEventListener('hbr-change', handleApiInstanceChange);
      selectApplication.removeEventListener('hbr-change', handleApplicationChange);
      selectSla.removeEventListener('hbr-change', handleSlaTierChange);
    } else {
      selectInstance.addEventListener('hbr-change', handleApiInstanceChange);
      selectApplication.addEventListener('hbr-change', handleApplicationChange);
      selectSla.addEventListener('hbr-change', handleSlaTierChange);
    }

}, [showPopup]);

  const getSelectValue = (e) => {
    if (e?.detail?.value !== undefined && e?.detail?.value !== null) {
      return String(e.detail.value);
    }
    if (e?.target?.value !== undefined && e?.target?.value !== null) {
      return String(e.target.value);
    }
    return '';
  };

  useEffect(() => {
    if (application && application !== 'Create Application') {
      getSLATiersList();
    }
  }, [application]);

  function handleApiInstanceChange(e) {
    setApiInstance(getSelectValue(e));
};

  const handleApplicationChange = (e) => {
    const selectedValue = getSelectValue(e);
    setApplication(selectedValue);
    if(selectedValue === 'Create Application') {
      setShowPopup(false);
    }
  };

  const handleSlaTierChange = (e) => {
    setSlaTier(getSelectValue(e));
  };

  const handleRequestReasonChange = (e) => {
    const textArea = e.target;
    let reasonMsgObj = {
      invalid: textArea.invalid ?? true,
      value: textArea.value ?? '',
      touched: requestReason.touched,
    };
    const inputLength = textArea.value?.length ?? 0;
    reasonMsgObj.helpText = `${inputLength} / ${LENGTH_RANGE.MAX}`;
    setRequestReason(reasonMsgObj);
  };

  const checkDisabled = () => {
    
    if (groupedSlaTiers.length > 0) {
      if (!requestReason.value || !slaTier || requestReason.invalid) {
        return true;
      }
    } else if (!requestReason.value || !application || requestReason.invalid) {
      return true;
    }

    return false;

  }

  const handleSubmit = (e) => {
    let selectedInstance  = groupedInstances.find(x=> String(x.apiInstanceId) === String(apiInstance))
                         || apiInstances.find(x=> String(x.apiInstanceId) === String(apiInstance));
    let seleApp = applications.find(x=> x.id === parseInt(application));
    let seleTier = groupedSlaTiers.find(x=> String(x.slaTierId) === String(slaTier));
    let autoApprove = seleTier ? seleTier.autoApprove : true;

    let payload = {
        "acceptedTerms": true,
        "apiInstanceId": selectedInstance.apiInstanceId,
        "instanceType": "api",
        "slaTierId": slaTier || "",
        "slaTierName": seleTier ? seleTier.slaTierName : "",
      //  "slaTierMaximumRequests": seleTier.limits[0].maximumRequests,
      //  "slaTierTimePeriodInMilliseconds": seleTier.limits[0].timePeriodInMilliseconds,
       // "autoApprove": seleTier.autoApprove,
        "version": selectedInstance.apiInstanceVersion,
        "versionGroup": config.versionGroup,
        "apiInstanceName": selectedInstance.apiInstanceName,
        "clientAppName": seleApp.name,
        "domainName": config.site,
        "subdomainName": config.apiGroup,
        "apiName": config.apiTitle,
        "meta": {
          "reason": requestReason.value,
        },
        "assetId": config.assetId,
        "organizationId": config.organizationId,
        "basePath": config.basePath,
        "apiInstanceGroup": selectedInstance.apiInstanceGroup || "",
       // "groupId": config.organizationId,
      }
    createRequestDetail(payload,seleApp.id,autoApprove)
    
  };

  const openPopup = (getInstance = true) => {
    setPoupupData(defaultPopupData);
    setShowPopup(true);
    setApplication('');
    setRequestReason({ value: "", invalid: true, error: false, helpText: `0 / ${LENGTH_RANGE.MAX}`, touched: false });
    setSlaTier('');
    if(getInstance) {
       setApiInstance('')
       fetchAPIInstances();
    } else {
      getApplications();
    }
  }

  const handleClose = () => {
    setShowPopup(false);
    setPoupupData(defaultPopupData);
  };

  useEffect(() => {
    if (props.errorResponse?.status == false) {
      hideLoader("failed");
      setPoupupData({title: "Request Failed", message: `${props.errorResponse?.data}`, status: "danger", showAlert: true, source: "requestAccess"});
    }
  }, [props.errorResponse])

  useEffect(() => {
    if (props.apiInstances.data) {
      hideLoader("fetchAPIInstances");
      setApiInstances(props.apiInstances.data);
      setGroupedInstances(groupApiInstances(props.apiInstances.data));
    }
  }, [props.apiInstances])

  useEffect(() => {
    if (props.applicationInsatnce.data) {
      hideLoader("getApplications");
      setApplications(props.applicationInsatnce.data.clients);
    }
  }, [props.applicationInsatnce])

  useEffect(() => {
    if (props.slaTiers.data) {
      hideLoader("getSLATiersList");
      setSlaTiers(props.slaTiers.data);
      // setSlaTiers([])
    }
  }, [props.slaTiers])
    

  async function fetchAPIInstances () {
    showLoader("fetchAPIInstances");
    props.dispatch(fetchAPIInstance(config.organizationId, config.assetId, config.versionGroup, resolvedGatewayName));
  }

  async function getApplications () {
    showLoader("getApplications");
    const firstInstanceId = apiInstance ? apiInstance.split(',')[0].trim() : apiInstance;
    props.dispatch(fetchApplications(config.organizationId, resolvedGatewayName, firstInstanceId));
  }

  async function getSLATiersList () {
    showLoader("getSLATiersList");
    props.dispatch(getSLATiers(config.organizationId, config.assetId, config.versionGroup, resolvedGatewayName, apiInstance));
  }

  async function createRequestDetail (payload,appId,autoApprove) {
    // showLoader();
    setPoupupData(defaultPopupData);
    // props.dispatch((createRequest(config.organizationId, appId, payload)));
    showLoader("createRequestDetail");
    try {
    const response = await window.fetch(`${API_BASE_PATH}/organizations/${config.organizationId}/applications/${appId}/accessRequests/create?gateway=${resolvedGatewayName}`,
      {
        method: 'POST',
        headers: commonHeaders,
        body: JSON.stringify(payload)
      });
      if(response.ok) {
        const data = await response.json();
        showConfirmationModal(autoApprove, data)
      } else {
        const errorData = await response.json();
        setPoupupData({title: "Request Failed", message: `${errorData.error}`, status: "danger", showAlert: true, source: "requestAccess"});
      }
      hideLoader("createRequestDetail");
    } catch (error) {
      hideLoader("createRequestDetail");
      setPoupupData({title: "Request Failed", message: `${error.error}`, status: "danger", showAlert: true, source: "requestAccess"});
      console.error('Error fetching request:', error);
    }
  }

 function showConfirmationModal(autoApprove, response) {
  setShowPopup(false);
  const firstResponse = Array.isArray(response) ? response[0] : response;
  if(!autoApprove) {
    setPopupConfig({
      header:"Request Sent",
      message:"Your request have sent successfully to the approver. You will get notifications once reviewer approve your request. Visit ‘My Apps’ for More details",
      okButtonLabel:"Close",
      cancelbuttonLabel:"",
      showCancel:false
  })
  } else {
        setPopupConfig({
          header:"Request Approved",
          message:"Your request has approved successfully. Visit ‘My Apps’ for More details. Use below client credentials to Access the API instance.",
          okButtonLabel:"Close",
          cancelbuttonLabel:"",
          showCancel:false,
          data: {
            client_id: firstResponse?.clientId,
            client_secret: firstResponse?.clientSecret
          }
      })

  }
  setShowConfirmation(true)
 }
 

 function  getslaDetails(tier) {
    if(tier && tier.limits) {
       const keys = Object.keys(tier.limits[0]);
        let limit = tier.limits[0];
       return `${keys[0]}: ${limit[keys[0]]}, ${keys[1]}: ${limit[keys[1]]}`;
    }
  }

  const createApplicationRecord = async (updatedData) => {
    setPoupupData(defaultPopupData);
    // props.dispatch((createApplication(config.organizationId, apiInstance, updatedData)));
    const firstInstanceId = apiInstance ? apiInstance.split(',')[0].trim() : apiInstance;
    showLoader("createApplicationRecord");
    try {
        const response = await window.fetch(`${API_BASE_PATH}/organizations/${config.organizationId}/applications?apiInstanceId=${firstInstanceId}&gateway=${resolvedGatewayName}&authType=${resolvedAuthProvider}`, {
          method: 'POST',
          body: JSON.stringify(updatedData),
          headers: commonHeaders,
        });
        
        if (response.ok) {
          const data = await response.json();
          openPopup(false);
          props.dispatch((reFetchApplication()));
          setPoupupData({title: "Success", message: "Application created successfully.", status: "success", showAlert: true, source: "requestAccess"});
        }
        else {
          const errorData = await response.json();
          setPoupupData({title: "Request Failed", message: `${errorData.error}`, status: "danger", showAlert: true, source: "createApplication"});
        }
        hideLoader("createApplicationRecord");
      } catch (error) {
        hideLoader("createApplicationRecord");
        setPoupupData({title: "Request Failed", message:`${error.error}`, status: "danger", showAlert: true, source: "createApplication"});
        console.error('Error creating application:', error);
      }
    };
  
    
    return (
        <>
        
    {application === 'Create Application' && 
       <EditOrCreateApplication show={application === 'Create Application'} showAlert={popupData.showAlert && popupData.source === "createApplication"} status={popupData.status} message={popupData.message} type={'Create'} onSubmit={(updatedData) => createApplicationRecord(updatedData)} 
       title={popupData.title}
       onClose={() => openPopup(false)} 
       visibility = {JSON.parse(config.visibility).content}
       gatewayName={resolvedGatewayName}
       allowCustomClientCredentials={allowCustomClientCredentials} />
    }
    {showConfirmation &&(
      <CommonConfiramation show={showConfirmation} popupConfig={popupConfig} onCancel={()=>setShowConfirmation(false)} onSubmit={()=>setShowConfirmation(false)}/>
    )}
    <Modal show={showPopup} centered onHide={handleClose} className='app-modal-popup fixed-width'>
      <Modal.Header className='app-modal-header' closeButton>
        <Modal.Title>Request Access</Modal.Title>
      </Modal.Header>
      <Modal.Body className='px-5 pt-4 requestAcces-body'>
        {popupData.showAlert && popupData.source === "requestAccess" && (
          <PopupAlert status={popupData.status} message={popupData.message} title={popupData.title} />
        )}
        <hbr-form autocomplete="off">
          
          <hbr-select 
          label="API Instance" 
          placeholder="Select API Instance" 
          clearable="false"
          required
          ref={selectInstanceRef}
          >
            {groupedInstances.map((app, index) => (
              <React.Fragment key={index}>
                <hbr-option value={String(app.apiInstanceId)}>{app.apiInstanceGroup || app.apiInstanceName}</hbr-option>
              </React.Fragment>
            ))}
          </hbr-select>

          <hbr-select 
          label="Application" 
          placeholder="Select Application" 
          clearable="false"
          disabled={!apiInstance}
          required
          ref={selectApplicationRef}
          >
              {applications.map((app, index) => (
                <React.Fragment key={index}>
                  <hbr-option value={String(app.id)}>{app.name}</hbr-option>
                </React.Fragment>
              ))}
              <React.Fragment>
                <hbr-option value="Create Application">Create Application</hbr-option>
              </React.Fragment>

          </hbr-select>

          <hbr-select 
          label="SLA Tier" 
          placeholder="Select SLA Tier" 
          clearable="false"
          disabled={!application}
          required={groupedSlaTiers.length > 0 ? true : false}
          ref={selectSlaRef}
          >
              {groupedSlaTiers.map((tier, index) => (
                <React.Fragment key={index}>
                  <hbr-option value={String(tier.slaTierId)}><span style={{fontSize: "16px"}}>{`${tier.slaTierName}`}</span><br /><span>{`(${getslaDetails(tier)})`}</span></hbr-option>
                </React.Fragment>
              ))}

          </hbr-select>

          <hbr-textarea
              ref={textAreaRef}
              pattern={TEXT_PATTERN}
              onInput={handleRequestReasonChange}
              label="Request Reason"
              name="requestReason"
              placeholder="Type your message here"
              required
              resize="none"
              maxLength={LENGTH_RANGE.MAX}
              minLength={LENGTH_RANGE.MIN}
              error={requestReason.touched && requestReason.invalid}
              onBlur={() => setRequestReason({ ...requestReason, touched: true })}
          >
            <div slot='label' className='denial_label'>Request Reason</div>
            <div slot='help-text' className='help-text d-flex justify-content-between'>
              <span>
                {requestReason.invalid && requestReason.touched && 'Please provide message with minimum 3 characters'}
              </span>
              <span>
                {requestReason.helpText}
              </span>
            </div>
          </hbr-textarea>

        </hbr-form>
      </Modal.Body>
      <Modal.Footer className='app-modal-footer'>
          <Button variant="secondary" onClick={handleClose}>
              Cancel
          </Button>
          <Button 
          disabled={checkDisabled()}
          variant="primary" 
          onClick={handleSubmit}
          >
              Request
          </Button>
      </Modal.Footer>
    </Modal>
    
    <a  className="hyperlink" onClick={() => openPopup()}>{data.title}</a>
        </>

  );
}

const mapStateToProps = (state) => {
  return {
      loader: state.request.isLoading,
      apiInstances: state.request.apiInstances,
      applicationInsatnce: state.request.applicationInsatnce,
      errorResponse: state.request.errorResponse,
      response: state.request.response,
      slaTiers: state.request.slaTiers
  }
}

export default connect(mapStateToProps)(RequestAccess);